export default __webpack_public_path__ + "static/media/bed.6bd8436d.svg";